import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation, Trans } from 'next-i18next';
import { ImageGalleryPreview } from '../../../../components/ImageGalleryPreview/index.js';
import { TourOperator } from '../../../../components/TravelDetailsOverlay/components/TourOperatorImages/components/TourOperator.js';
import { Flex, HeadlineLarge, Notice } from '../../../../primitives/index.js';
export const TourOperatorImages = ({
  tourOperator,
  images,
  onClickImage
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  // ....
  if (images.length === 0) {
    return null;
  }
  return _jsxs(Flex, {
    spacing: "pages/small",
    children: [_jsxs(Flex, {
      direction: "row",
      alignItems: "center",
      justifyContent: "space-between",
      children: [_jsx(HeadlineLarge, {
        children: t('tourOperatorImages.title')
      }), tourOperator && _jsx(TourOperator, {
        tourOperator: tourOperator
      })]
    }), _jsx(ImageGalleryPreview, {
      images: images,
      onClickImage: onClickImage
    }), tourOperator.name && _jsx(Notice, {
      variant: "info",
      children: _jsx(Trans, {
        i18nKey: "travelDetailsOverlay:tourOperatorImages.notice",
        values: {
          tourOperator: tourOperator.name
        }
      })
    })]
  });
};